<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 4.5807C14.9192 4.5807 10.65 8.7719 10.65 14.1247C10.65 15.8753 11.5571 17.5118 12.677 19.5322C12.7646 19.6903 12.8535 19.8507 12.9434 20.0138L20.0062 32.8219L27.1449 19.9862C28.3548 17.8107 29.35 16.0106 29.35 14.1247C29.35 8.7719 25.0808 4.5807 20 4.5807ZM28.6928 20.5647C29.8227 18.5348 31 16.4196 31 14.1247C31 7.98068 26.0751 3 20 3C13.9249 3 9 7.98068 9 14.1247C9 16.2907 10.1075 18.2787 11.1805 20.2046C11.2825 20.3877 11.3841 20.5701 11.4845 20.7521L19.0315 34.4384C19.4436 35.1857 20.5601 35.1876 20.975 34.4417L28.6011 20.7294C28.6316 20.6746 28.6622 20.6197 28.6928 20.5647Z"
      class="fill-current"
    />
    <path
      d="M24 14C24 16.2091 22.2091 18 20 18C17.7909 18 16 16.2091 16 14C16 11.7909 17.7909 10 20 10C22.2091 10 24 11.7909 24 14Z"
      class="fill-current"
    />
  </svg>
</template>
